import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { TaskChecklistItem } from "core/queries/GetTask";
import {
  UpdateTaskChecklistItem as UpdateTaskChecklistItemGenerated,
  UpdateTaskChecklistItem_updateTaskChecklistItem as UpdateTaskChecklistItemPayloadGenerated,
  UpdateTaskChecklistItemVariables as UpdateTaskChecklistItemVariablesGenerated,
} from "core/queries/__generated__/UpdateTaskChecklistItem";

export interface UpdateTaskChecklistItemVariables
  extends UpdateTaskChecklistItemVariablesGenerated {}

export interface UpdateTaskChecklistItemResponse
  extends UpdateTaskChecklistItemGenerated {}

export interface UpdateTaskChecklistItemPayload
  extends UpdateTaskChecklistItemPayloadGenerated {}

export const updateTaskChecklistItem = gql`
  mutation UpdateTaskChecklistItem(
    $checklistItemId: ID!
    $name: String!
    $required: Boolean
    $status: ChecklistItemStatus!
  ) {
    updateTaskChecklistItem(
      checklistItemId: $checklistItemId
      name: $name
      required: $required
      status: $status
    ) {
      checklistItem {
        id
        name
        required
        status
      }
    }
  }
`;

interface UseUpdateTaskChecklistItemQueryOptions {
  awaitRefetchQueries?: boolean;
  optimisticResponse?: UpdateTaskChecklistItemResponse;
  refetchQueries?: string[];
  variables?: UpdateTaskChecklistItemVariables;
}

type OptimisticResponse = Omit<TaskChecklistItem, "__typename">;
export const updateTaskChecklistItemOptimisticResponse = (
  response: OptimisticResponse,
) => ({
  updateTaskChecklistItem: {
    checklistItem: {
      id: response.id,
      createdAt: response.createdAt,
      name: response.name,
      required: response.required,
      status: response.status,
      __typename: "TaskChecklistItem" as TaskChecklistItem["__typename"],
    },
    __typename:
      "UpdateItemPayload" as UpdateTaskChecklistItemPayload["__typename"],
  },
});

export const useUpdateTaskChecklistItem = ({
  awaitRefetchQueries = false,
  refetchQueries = [],
  optimisticResponse,
  variables,
}: UseUpdateTaskChecklistItemQueryOptions) =>
  useMutation<
    UpdateTaskChecklistItemResponse,
    UpdateTaskChecklistItemVariables
  >(updateTaskChecklistItem, {
    awaitRefetchQueries,
    optimisticResponse,
    refetchQueries,
    variables,
  });
